import ServiceCRUD from '../../../../services/ServiceCRUDFLEXUC';

class UserServiceUpdateAll extends ServiceCRUD {
  constructor() {
    super('/api/usuarios-range');
  }
}

export default new UserServiceUpdateAll();
